import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { companyInfo } from '../mockData';
import { trackPhoneClick } from '../utils/analytics';

export const StickyCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Mobil cihaz kontrolü
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Scroll kontrolü
    const handleScroll = () => {
      // 100px aşağı scroll yapınca butonu göster
      setIsVisible(window.scrollY > 100);
    };

    checkMobile();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Sadece mobilde göster
  if (!isMobile) {
    return null;
  }

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <a
        href={`tel:${companyInfo.phone}`}
        onClick={() => trackPhoneClick('sticky_mobile_button')}
        className="flex items-center justify-center bg-gradient-to-r from-[#4A7C3A] to-[#8AC73E] text-white py-3 px-4 shadow-lg hover:shadow-xl transition-all duration-300 group"
      >
        <div className="flex items-center space-x-3 animate-pulse group-hover:animate-none">
          <div className="bg-white/20 p-2 rounded-full group-hover:scale-110 transition-transform duration-200">
            <Phone size={20} className="animate-bounce group-hover:animate-none" />
          </div>
          <div className="text-left">
            <p className="text-xs font-medium opacity-90">Hemen Arayın</p>
            <p className="text-sm font-bold">{companyInfo.phone}</p>
          </div>
        </div>
        
        {/* Pulse efekti */}
        <div className="absolute inset-0 bg-[#8AC73E] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
      </a>
    </div>
  );
};
